import {
  DuelVotesListResponseSchema,
  UniqueVotersResponseSchema,
  VotesCountResponseSchema,
  VoteOnDuelRequestSchema,
  VoteOnDuelResponseSchema,
  type DuelVotesListResponse,
  type UniqueVotersResponse,
  type VotesCountResponse,
  type VoteOnDuelRequest,
  type VoteOnDuelResponse,
} from '@/types/duelVotes';
import { apiRequest } from './client';

const BASE = '/api/v1/duel_votes';

export type DuelVotesOrder = 'created_at.desc' | 'created_at.asc' | 'updated_at.desc' | 'updated_at.asc' | 'predictor_rating.desc' | 'predictor_rating.asc';

export interface GetDuelVotesParams {
  duel_id?: string;
  user_id?: string;
  selected_player_id?: string;
  order?: DuelVotesOrder;
  limit?: number;
  offset?: number;
}

export async function getDuelVotes(params: GetDuelVotesParams = {}): Promise<DuelVotesListResponse> {
  const query = new URLSearchParams();
  if (params.duel_id) query.set('duel_id', params.duel_id);
  if (params.user_id) query.set('user_id', params.user_id);
  if (params.selected_player_id) query.set('selected_player_id', params.selected_player_id);
  if (params.order) query.set('order', params.order);
  if (params.limit !== undefined) query.set('limit', String(params.limit));
  if (params.offset !== undefined) query.set('offset', String(params.offset));

  const qs = query.toString();
  const url = `${BASE}${qs ? `?${qs}` : ''}`;
  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return DuelVotesListResponseSchema.parse(res);
}

export async function getUniqueVoters(): Promise<UniqueVotersResponse> {
  const url = `${BASE}/unique-voters`;
  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return UniqueVotersResponseSchema.parse(res);
}

export async function getDuelVotesCountById(duelId: string): Promise<VotesCountResponse> {
  const url = `${BASE}/count/${duelId}`;
  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return VotesCountResponseSchema.parse(res);
}

export async function getDuelVotesCountBatch(duelIds: string[]): Promise<VotesCountResponse> {
  const query = new URLSearchParams();
  query.set('duel_ids', duelIds.join(','));
  const url = `${BASE}/count?${query.toString()}`;
  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return VotesCountResponseSchema.parse(res);
}

export async function voteOnDuel(body: VoteOnDuelRequest): Promise<VoteOnDuelResponse> {
  // validate body locally
  const payload = VoteOnDuelRequestSchema.parse(body);
  const url = `${BASE}/vote-on-duel`;
  const res = await apiRequest<unknown>({ url, method: 'POST', data: payload });
  return VoteOnDuelResponseSchema.parse(res);
}

